export default [
  {
    header: 'ลงทะเบียน',
  },
  {
    title: 'จองคิวศูนย์',
    route: 'addnamelist',
    icon: 'UserPlusIcon',
    roles: ['customer'], // เฉพาะ customer
  },
  {
    title: 'จองคิวศูนย์ด้วยไฟล์',
    route: 'namelist',
    icon: 'FileIcon',
    roles: ['customer'],
  },
  {
    title: 'แก้ไขคิวศูนย์',
    route: 'Editnamelist',
    icon: 'EditIcon',
    roles: ['customer'],
  },
  {
    title: 'อัพเดทคิวด่านชายแดน',
    route: 'search',
    icon: 'RefreshCcwIcon',
    // ไม่มี roles => ทุกคนเห็น
  },
  {
    title: 'แก้ไขข้อมูลแรงงาน',
    route: 'updatenamelist',
    icon: 'EditIcon',
    // ไม่มี roles => ทุกคนเห็น
  },
  {
    header: 'รายงาน',
  },
  {
    title: 'รายงานคิวด่านชายแดน',
    route: 'reportlist',
    icon: 'FileTextIcon',
    //roles: ['admin'], // เฉพาะ admin
  },
  {
    header: 'ตั้งค่า',
  },
  {
    title: 'เพิ่มเจ้าหน้าที่',
    route: 'userlist',
    icon: 'UserPlusIcon',
    titlesToCheck: 'UserID ผู้ใช้งาน',
   // roles: ['admin'],
  },
  {
    title: 'ข้อมูลด่านชายแดน',
    route: 'config',
    icon: 'MapPinIcon',
    titlesToCheck: 'ข้อมูลด่านชายแดน',
   // roles: ['admin'],
  },
  {
    title: 'ข้อมูลศูนย์แรงงานต่างด้าว',
    route: 'workerscenter',
    icon: 'GridIcon',
    titlesToCheck: 'ข้อมูลศูนย์แรงงานต่างด้าว',
    //roles: ['admin'],
  },
]
